import { render, staticRenderFns } from "./MealsSchoolList.vue?vue&type=template&id=59a1459d&scoped=true&"
import script from "./MealsSchoolList.vue?vue&type=script&lang=js&"
export * from "./MealsSchoolList.vue?vue&type=script&lang=js&"
import style0 from "./MealsSchoolList.vue?vue&type=style&index=0&id=59a1459d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a1459d",
  null
  
)

export default component.exports